import React from 'react';
import { Settings as SettingsIcon, Shield, CreditCard, Users } from 'lucide-react';
export const AdminSettings = () => {
  const tierDefaults = [{
    tier: 1,
    individual: 300000,
    company: 250000,
    label: 'Tier 1 — Premium'
  }, {
    tier: 2,
    individual: 150000,
    company: 150000,
    label: 'Tier 2 — Upper-Mid'
  }, {
    tier: 3,
    individual: 50000,
    company: 50000,
    label: 'Tier 3 — Growing'
  }];
  return <div className="space-y-6 animate-in fade-in" data-id="element-513">
      <div data-id="element-514">
        <h1 className="text-2xl font-serif font-bold text-slate-900 dark:text-white mb-1" data-id="element-515">
          Platform Settings
        </h1>
        <p className="text-slate-500 dark:text-slate-400" data-id="element-516">
          Configure global platform parameters.
        </p>
      </div>

      <div className="grid lg:grid-cols-2 gap-6" data-id="element-517">
        <div className="bg-white dark:bg-[#1e293b] rounded-2xl border border-slate-200 dark:border-slate-700 p-6" data-id="element-518">
          <div className="flex items-center gap-3 mb-2" data-id="element-519">
            <CreditCard className="text-secondary" data-id="element-520" />
            <h2 className="text-lg font-bold text-slate-900 dark:text-white" data-id="element-521">
              Tier Pricing
            </h2>
          </div>
          <p className="text-xs text-slate-500 dark:text-slate-400 mb-6" data-id="element-522">
            Listing fees split by seller type, per AMU tier model.
          </p>

          <div className="space-y-4" data-id="element-523">
            {tierDefaults.map(t => <div key={t.tier} className="p-4 rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/50" data-id="element-524">
                <div className="text-sm font-bold text-slate-900 dark:text-white mb-3" data-id="element-525">
                  {t.label}
                </div>
                <div className="grid grid-cols-2 gap-3" data-id="element-526">
                  <div data-id="element-527">
                    <label className="block text-xs font-bold text-slate-600 dark:text-slate-400 mb-1.5 uppercase tracking-wider" data-id="element-528">
                      Individual (₦)
                    </label>
                    <input type="number" defaultValue={t.individual} className="w-full px-3 py-2 rounded-lg bg-white dark:bg-slate-800 border border-slate-300 dark:border-slate-600 text-slate-900 dark:text-white text-sm focus:ring-2 focus:ring-secondary outline-none" data-id="element-529" />
                  </div>
                  <div data-id="element-530">
                    <label className="block text-xs font-bold text-slate-600 dark:text-slate-400 mb-1.5 uppercase tracking-wider" data-id="element-531">
                      Company / Estate (₦)
                    </label>
                    <input type="number" defaultValue={t.company} className="w-full px-3 py-2 rounded-lg bg-white dark:bg-slate-800 border border-slate-300 dark:border-slate-600 text-slate-900 dark:text-white text-sm focus:ring-2 focus:ring-secondary outline-none" data-id="element-532" />
                  </div>
                </div>
              </div>)}
            <button className="px-4 py-2 bg-secondary text-primary-900 font-bold rounded-lg hover:bg-secondary-dark transition-colors" data-id="element-533">
              Save Pricing
            </button>
          </div>
        </div>

        <div className="bg-white dark:bg-[#1e293b] rounded-2xl border border-slate-200 dark:border-slate-700 p-6" data-id="element-534">
          <div className="flex items-center gap-3 mb-6" data-id="element-535">
            <Shield className="text-secondary" data-id="element-536" />
            <h2 className="text-lg font-bold text-slate-900 dark:text-white" data-id="element-537">
              Verification SLA
            </h2>
          </div>
          <div className="space-y-4" data-id="element-538">
            <div data-id="element-539">
              <label className="block text-sm font-bold text-slate-700 dark:text-slate-300 mb-2" data-id="element-540">
                Target Resolution Time (Hours)
              </label>
              <input type="number" defaultValue="48" className="w-full px-4 py-2 rounded-lg bg-white dark:bg-slate-800 border border-slate-300 dark:border-slate-600 text-slate-900 dark:text-white focus:ring-2 focus:ring-secondary outline-none" data-id="element-541" />
            </div>
            <div className="flex items-center justify-between p-4 border border-slate-200 dark:border-slate-700 rounded-lg bg-slate-50 dark:bg-slate-800/50" data-id="element-542">
              <div data-id="element-543">
                <h4 className="font-bold text-slate-900 dark:text-slate-200 text-sm" data-id="element-544">
                  Auto-flag Duplicates
                </h4>
                <p className="text-xs text-slate-500 dark:text-slate-400" data-id="element-545">
                  AI detection for duplicate title docs
                </p>
              </div>
              <input type="checkbox" defaultChecked className="rounded border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-secondary focus:ring-secondary" data-id="element-546" />
            </div>
            <button className="px-4 py-2 bg-secondary text-primary-900 font-bold rounded-lg hover:bg-secondary-dark transition-colors" data-id="element-547">
              Save SLA Settings
            </button>
          </div>
        </div>
      </div>
    </div>;
};